import { useState } from 'react';

const navItems = [
  { label: '今日快讯', href: '#feed' },
  { label: '封面深挖', href: '#deepdive' },
  { label: '深挖栏目', href: '#channels' },
  { label: '推手图谱', href: '#pushers' },
  { label: '读者热评', href: '#voices' },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/90 backdrop-blur-md">
      <div className="flex h-16 items-center justify-between gap-4 px-4 md:h-[76px] md:px-8">
        <a href="#top" className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
            17
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">
              17爆料网
            </span>
            <span className="mt-1 hidden text-[10px] tracking-[0.26em] text-foreground-500 md:block">
              内幕深挖 · 幕后推手档案
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 md:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <span className="hidden items-center gap-2 whitespace-nowrap text-xs text-foreground-500 lg:flex">
            <i className="ri-calendar-line text-sm" />
            2026.09.12 周六
          </span>
          <a
            href="#subscribe"
            className="hidden items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-send-plane-line text-base" />
            我要爆料
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-2 md:hidden">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="border-b border-background-100 py-3 text-sm text-foreground-800 transition-colors hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#subscribe"
            onClick={() => setOpen(false)}
            className="mt-4 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50"
          >
            <i className="ri-send-plane-line text-base" />
            我要爆料
          </a>
        </div>
      ) : null}
    </header>
  );
}